import React from "react";

export default function SkynetIcon({ icon, title, onClick = undefined, disabled = undefined, filled = false })
{
    return <span className={`vismaicon ${filled ? "vismaicon-filled" : "vismaicon-dynamic"} ${icon}${onClick ? " cursorpointer" : ""} ${disabled ? "disabled" : ""}`} title={title} onClick={onClick} tabIndex={onClick ? "0" : "-1"}></span>
}